export function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

/**
 * @param {string} name
 * @param {string|number} value
 * @param {number} age
 * @param {string} path
 */
export function setCookie(name, value, age = 0, path = '/') {
    let date = new Date(new Date().getTime() + age * 1000);

    let parts = [];
    parts.push(name + "=" + value);

    if (path) parts.push("path=" + path);
    if (age > 0) parts.push("expires=" + date.toUTCString());

    document.cookie = parts.join("; ");
}

export function deleteCookie(name, path = '/') {
    setCookie(name, '', -1, path);
}


// WEBPACK FOOTER //
// ./src/utils/cookie.js